import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateData, resetFilters } from "../redux/activitiesSaga";

export const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.activities.filtersDirty);
  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(updateData())}>
        Update
      </button>
      <button className="submit reset" onClick={() => dispatch(resetFilters())}>
        Reset
      </button>
    </>
  ) : null;
};
